"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var imageAspectRatios = ['1:1', '16:9', '4:3', '5:4', '3:4'];
var _default = exports["default"] = imageAspectRatios;